import { render, staticRenderFns } from "./CreateAboutTheWard.vue?vue&type=template&id=21e2e922&scoped=true&"
import script from "./CreateAboutTheWard.vue?vue&type=script&lang=js&"
export * from "./CreateAboutTheWard.vue?vue&type=script&lang=js&"
import style0 from "./CreateAboutTheWard.vue?vue&type=style&index=0&id=21e2e922&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2e922",
  null
  
)

export default component.exports